import React, { Fragment } from 'react'
import { connect } from 'react-redux'
import styles from './TourismEmbedConfigurator.scss'
import { loadOrCreateRSO, loadGeoJSON } from 'lib/api/embeds/regional'
import { RegionalEmbedlet } from 'features/embed/RegionalEmbed/RegionalEmbedlet'
import { EmbedFormContainer } from './EmbedForm'
import { CircleSpinner } from 'common/spinners/CircleSpinner'
import cx from 'classnames'
import _ from 'lodash'
import queryString from 'query-string'

export class TourismEmbedConfigurator extends React.Component {
  componentDidMount = () => {
    const { loadOrCreateRSO, id } = this.props

    loadOrCreateRSO(id)
  }

  componentDidUpdate = (prevProps) => {
    const { loadGeoJSON } = this.props

    // Load geoJSON if we have specified a route tag, and if the incoming route_ids are different that the previous ones (i.e. the route tag changed)
    const currentRouteIds = this.props.embedData.get('rso').route_ids || []
    const previousRouteIds = prevProps.embedData.get('rso').route_ids || []

    if (this.props.embedData.get('routeTag') && currentRouteIds.length > 0 && (currentRouteIds.length !== previousRouteIds.length || _.intersection(currentRouteIds, previousRouteIds).length !== currentRouteIds.length)) {
      loadGeoJSON(this.props.id, this.props.embedData.get('rso').updated_at)
    }

    // Stick the id in the querystring, if we didn't have one before.
    if (!prevProps.id && this.props.id) {
      const parsed = queryString.parse(window.location.search)
      parsed.id = this.props.id
      window.history.replaceState(null, null, window.location.pathname + '?' + queryString.stringify(parsed))
    }
  }

  render () {
    const { id, saving, embedData, geoJSON } = this.props
    // there will always be a clubId for a loaded embed
    const loaded = !!embedData.get('clubId')

    const boundingBox = embedData.getIn(['embedSettings', 'boundingBox'])
    const poiBar = embedData.getIn(['embedSettings', 'poiBar'])
    const metricUnits = embedData.getIn(['embedSettings', 'metricUnits'])
    const overlay = embedData.getIn(['embedSettings', 'overlay'])

    const boundsArr = boundingBox && boundingBox.split(',').map(parseFloat)
    const parsedBounds = boundsArr && [
      [boundsArr[1], boundsArr[0]],
      [boundsArr[3], boundsArr[2]]
    ]

    const embedletDetails = {
      colors: embedData.get('colors'),
      urls: embedData.get('urls'),
      poiTags: embedData.get('poiTags')
    }

    return (
      <div className={styles.TourismEmbedConfigurator}>
        <div className={styles.LeftPanel}>
          <EmbedFormContainer id={id} />
        </div>
        <div className={styles.Preview}>
          <div className={styles.embed}>
            {loaded && <RegionalEmbedlet
              editing
              type='region'
              poiBar={poiBar}
              initialBounds={parsedBounds}
              overlay={overlay}
              metricUnits={metricUnits}
              details={embedletDetails}
              rso={embedData.get('rso')}
              assets={embedData.get('assets')}
              pois={embedData.get('pois')}
              geoJSON={geoJSON}
              enabledPoiTags={embedData.get('enabledPoiTags')} />}
          </div>
          <div className={cx(styles.savingIndicator, saving ? styles.savingInProgress : styles.savingComplete)}>
            {saving && <Fragment><CircleSpinner size={15} /> Saving...</Fragment>}
            {!saving && 'Saved!'}
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  const id = parseInt(ownProps.id, 10)
  const { regionalEmbed } = state

  const embedData = regionalEmbed.get('embedData')

  return {
    id: embedData.get('id') || id,
    embedData: embedData,
    poiBar: regionalEmbed.get('poiBar'),
    boundingBox: ownProps.boundingBox || regionalEmbed.get('boundingBox'),
    type: regionalEmbed.get('type'),
    metricUnits: regionalEmbed.get('metricUnits'),
    overlay: regionalEmbed.get('overlay'),
    geoJSON: regionalEmbed.get('geoJSON'),
    routes: regionalEmbed.get('routes'),
    saving: regionalEmbed.get('saving')
  }
}

const mapDispatchToProps = {
  loadOrCreateRSO: loadOrCreateRSO,
  loadGeoJSON: loadGeoJSON
}

export const TourismEmbedConfiguratorContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(TourismEmbedConfigurator)
